@if (title) {
  <div class="section-header">{{ title }}</div>
}
<div class="section-grid" [style.grid-template-columns]="gridColumns">
  <ng-content />
</div>
